import React, { useEffect, useState } from 'react';
import './css/Testimonials.css';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const defaultReviews = [
  { source: 'International Legal Partner', text: 'Their seamless on-the-ground support and deep understanding of local frameworks made our expansion into the region effortless. A true extension of our team.', initial: 'ILP', image: '' },
  { source: 'Regional Enterprise', text: 'Whales Advisory demonstrates absolute loyalty to our interests and handles every matter with utmost care. We would not navigate the Egyptian market without them.', initial: 'RE', image: '' },
  { source: 'GCC Family Office', text: 'From structuring to compliance, their team delivered with precision. We value the clarity and reliability they bring to every engagement.', initial: 'GF', image: '' },
  { source: 'Egyptian Conglomerate', text: 'They understand both local regulations and international standards. Our go-to advisors for high-stakes transactions and day-to-day governance.', initial: 'EC', image: '' },
  { source: 'International Law Firm', text: 'Whales Advisory is our trusted local counsel in Egypt. Responsive, thorough, and always aligned with our clients\' best interests.', initial: 'IL', image: '' },
  { source: 'SME Founder', text: 'They made company formation and licensing straightforward. Professional, transparent, and genuinely invested in our success.', initial: 'SF', image: '' },
];

const Testimonials = () => {
  const [reviews, setReviews] = useState(defaultReviews);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/testimonials`);
        if (Array.isArray(res.data?.testimonials) && res.data.testimonials.length > 0) {
          setReviews(res.data.testimonials);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchTestimonials();
  }, []);

  return (
    <motion.section
      className="testimonials-wrapper"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <p className="subtitle">OUR CLIENTS</p>
          <h2 className="title">Uncompromising Dedication to Our Clients</h2>
          <p className="testimonials-tagline">Reliable Legal Extension across Egypt and the GCC</p>
        </div>

        <Swiper
          modules={[Autoplay]}
          loop
          speed={6500}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          spaceBetween={24}
          breakpoints={{
            0: { slidesPerView: 1.2 },
            576: { slidesPerView: 1.5 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 2.5 },
            1200: { slidesPerView: 2 },
          }}
          className="testimonials-swiper"
        >
          {reviews.map((item, idx) => {
            const avatarSrc = !item.image
              ? ''
              : item.image.startsWith('http')
                ? item.image
                : `${API_BASE_URL}${item.image}`;

            return (
              <SwiperSlide key={idx}>
                <div className="testimonial-card">
                  <div className="card-header">
                    {avatarSrc ? (
                      <img
                        src={avatarSrc}
                        alt=""
                        className="client-avatar"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          const fallback = e.target.nextElementSibling;
                          if (fallback) fallback.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <div
                      className="client-initial"
                      style={
                        avatarSrc
                          ? { display: 'none', marginRight: 0 }
                          : undefined
                      }
                    >
                      {item.initial}
                    </div>
                    <div className="client-info">
                      <h4>{item.source}</h4>
                    </div>
                  </div>
                  <p className="quote">"{item.text}"</p>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </motion.section>
  );
};

export default Testimonials;
